import axios from 'axios';
import $ from 'jquery';
import 'jquery-confirm';

export const handleApiError = (err, setAuthForm, path) => {
    if (err && err.response) {
        if (err.response.status === 401) {
            if (setAuthForm) setAuthForm(true);
        } else if (err.response.status === 404) {
            console.log(path, err.response.status, ':', err.response.statusText);
        } else if (err.response.status === 500) {
            console.log(path, err.response.status, ':', err.response.statusText);
        } else {
            console.log(path, err.response.status, ':', err.response.data);
        }
    } else {
        if ($ && $.dialog) {
            $.dialog({
                title: "Can't reach server!",
                content: 'Please check internet connection!',
            });
        } else {
            console.error("Network error or jquery-confirm not loaded");
        }
    }
};

export const makeGetCall = (link, path, accessToken, loadFn, setFn, setAuthForm) => {
    if (loadFn) loadFn(true);
    return axios.get(`${link}${path}`, {
        headers: {
            Authorization: 'Bearer ' + accessToken
        }
    }).then(response => {
        if (loadFn) loadFn(false);
        if (setFn) setFn(response.data);
        return response;
    }).catch(err => {
        if (loadFn) loadFn(false);
        handleApiError(err, setAuthForm, path);
        throw err;
    });
};

export const makePostCall = (link, path, data, accessToken, setAuthForm) => {
    return new Promise((resolve, reject) => {
        axios.post(`${link}${path}`, data, {
            headers: {
                Authorization: accessToken !== undefined ? 'Bearer ' + accessToken : ''
            }
        }).then((response) => {
            resolve({ data: response.data });
        }).catch((err) => {
            handleApiError(err, setAuthForm, path);
            reject(err);
        });
    });
};
